module.exports = __webpack_public_path__ + "media/images/undraw/matching/push_notifications-ba083826b512fda7d21c083fc7180d19.png";